<template>
    <li @click="selectValue">{{label}}</li>
</template>
<script>
export default {
    name: "mOption",
    props: {
		label:{
			type:String,
			default: ''
		},
		value:{
			type:String,
			default: ''
		}
    },
    data() {
        return {
            
        }
    },
    watch:{
       '$parent.myValue':function(){
            if(this.$parent.myValue === this.value){
                this.$parent.name  = this.label;
            }
       }
    },
    mounted() {
        if(this.$parent.myValue === this.value){
			this.$parent.name  = this.label;
		}
    },
    created() {
		
    },
    methods: {
        selectValue (){
            this.$parent.myValue = this.value;
			this.$parent.name = this.label;
			this.$parent.show = false;
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/form/drowDown/option.vue